import classNames from 'classnames';
import React from 'react';

function PointRight({ color = 'text-shuttle-grey', size = 'w-4 h-4' }) {
	return (
		<svg
			viewBox="0 0 16 16"
			fillRule="evenodd"
			fill="none"
			className={classNames(color, size)}
			transform="translate(1 1)"
			strokeWidth="2"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g
				id="icon/monochrome/functions/navigation/point-right"
				stroke="none"
				strokeWidth="1"
				fill="none"
				className="fill-current"
				fillRule="evenodd"
			>
				<g id="export">
					<rect id="box" fillOpacity="0" fill="#277CD9" x="0" y="0" width="16" height="16" />
					<path
						d="M3.34506952,3.25574396 C3.06123896,2.9719134 2.90063916,2.60253386 2.90063916,2.19872167 C2.90063916,1.79490948 3.06123896,1.42552995 3.34506952,1.14169939 L4.04233855,0.444430359 C4.32616911,0.160599797 4.69554865,0 5.09936084,0 C5.50317303,0 5.87255256,0.160599797 6.15638312,0.444430359 L12.6549305,6.94297772 C12.938761,7.22680828 13.0993608,7.59618781 13.0993608,8 C13.0993608,8.40381219 12.938761,8.77319172 12.6549305,9.05702228 L6.15638312,15.5555696 C5.87255256,15.8394002 5.50317303,16 5.09936084,16 C4.69554865,16 4.32616911,15.8394002 4.04233855,15.5555696 L3.34506952,14.8583006 C3.06123896,14.57447 2.90063916,14.2050905 2.90063916,13.8012783 C2.90063916,13.3974661 3.06123896,13.0280866 3.34506952,12.744256 L8.08932556,8 L3.34506952,3.25574396 Z"
						id="point-right"
					/>
				</g>
			</g>
		</svg>
	);
}

export default PointRight;
